// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
// Module
exports.push([module.id, ".v-btn.v-btn--disabled.step-ind:disabled{background-color:#efefef!important}.step-divider{margin:0 -10px}.step-divider.disabled{background-color:#efefef!important}.step-divider .fill{transition:width .1s ease-in-out}", ""]);
// Exports
module.exports = exports;
